import { handleRequest } from "../utilities/requestHandler";

export const getMachinesWithModels = (req_body) =>
    handleRequest("post","/machines/with-models",req_body);

export const getMachinesByIds = (req_body) =>
    handleRequest("post", "/machines/by-ids", req_body);

export const getMachineByNumberOrId = (req_body) =>
    handleRequest("post", "/machines/by-number-or-id", req_body);
